import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/theme.css';

const ALLOWED_DOMAINS = ['24inspector.ru', '://24inspector.ru', '212.113.122.144', '://212.113.122.144', 'localhost'];

if (!ALLOWED_DOMAINS.includes(window.location.hostname)) {
  window.location.replace('https://24inspector.ru' + window.location.pathname + window.location.search);
} else {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );

  reportWebVitals();
}
